import { queryEncode } from 'cio/helpers/query';

export const CONFIG = Object.freeze({
  campaign: {
    id: '1',
    name: 'RescueTime Onboarding',
    description:
      'Goal: Follow-up with self-service and more enterprise customers differently, prompting them to take appropriate next steps with RescueTime.',
    type: 'behavioral',
    anchors: queryEncode([{ negate: false, segments: [1], type: 'segments_negatable' }]),
    filters: '',
    workflow_action_ids: [
      '60',
      '61',
      '62',
      '63',
      '64',
      '65',
      '66',
      '69',
      '70',
      '71',
      '72',
      '73',
      '74',
      '75',
      '76',
      '77',
      '78',
      '79',
      '80',
      '86',
      '88',
      '90',
      '91',
      '92',
      '93',
      '94',
    ],
    edges: [
      {
        from: '60',
        to: '69',
        type: 'continue',
      },
      {
        from: '62',
        to: '86',
        type: 'continue',
      },
      {
        from: '63',
        to: '62',
        type: 'continue',
      },
      {
        from: '64',
        to: '65',
        type: 'continue',
      },
      {
        from: '65',
        to: '88',
        type: 'continue',
      },
      {
        from: '66',
        to: '61',
        type: 'continue',
      },
      {
        from: '69',
        to: '63',
        type: 'branch',
        index: 0,
      },
      {
        from: '69',
        to: '70',
        type: 'branch',
        index: 1,
      },
      {
        from: '69',
        to: '61',
        type: 'branch',
        index: 2,
      },
      {
        from: '70',
        to: '71',
        type: 'continue',
      },
      {
        from: '71',
        to: '90',
        type: 'continue',
      },
      {
        from: '72',
        to: '79',
        type: 'continue',
      },
      {
        from: '73',
        to: '80',
        type: 'continue',
      },
      {
        from: '74',
        to: '75',
        type: 'continue',
      },
      {
        from: '75',
        to: '93',
        type: 'continue',
      },
      {
        from: '76',
        to: '78',
        type: 'continue',
      },
      {
        from: '77',
        to: '61',
        type: 'continue',
      },
      {
        from: '78',
        to: '94',
        type: 'continue',
      },
      {
        from: '79',
        to: '91',
        type: 'continue',
      },
      {
        from: '80',
        to: '92',
        type: 'continue',
      },
      {
        from: '86',
        to: '64',
        type: 'continue',
      },
      {
        from: '88',
        to: '66',
        type: 'continue',
      },
      {
        from: '90',
        to: '72',
        type: 'continue',
      },
      {
        from: '91',
        to: '73',
        type: 'continue',
      },
      {
        from: '92',
        to: '74',
        type: 'continue',
      },
      {
        from: '93',
        to: '76',
        type: 'continue',
      },
      {
        from: '94',
        to: '77',
        type: 'continue',
      },
    ],
  },
  actions: [
    {
      id: '60',
      type: 'filter_match_delay_action',
      campaign_id: '1',
    },
    {
      id: '61',
      type: 'exit_action',
      campaign_id: '1',
    },
    {
      id: '62',
      type: 'delay_seconds_action',
      action_state: 'running',
      delay: 604800,
      campaign_id: '1',
    },
    {
      id: '63',
      type: 'email_action',
      action_state: 'running',
      subject: "You're confirmed! + next steps",
      name: 'Account Confirmation',
      sending_state: 'automatic',
      tracked: true,
      use_message_limits: null,
      has_content: true,
      has_subject: true,
      send_to_unsubscribed: null,
      campaign_id: '1',
    },
    {
      id: '64',
      type: 'email_action',
      action_state: 'running',
      subject: 'Get to Know RescueTime',
      name: 'Platform Training',
      sending_state: 'automatic',
      tracked: true,
      use_message_limits: null,
      has_content: true,
      has_subject: true,
      send_to_unsubscribed: null,
      campaign_id: '1',
    },
    {
      id: '65',
      type: 'delay_seconds_action',
      action_state: 'running',
      delay: 691200,
      campaign_id: '1',
    },
    {
      id: '66',
      type: 'email_action',
      action_state: 'running',
      subject: 'Anything we can help with? ',
      name: 'Customer Success Check-in',
      sending_state: 'automatic',
      tracked: true,
      use_message_limits: null,
      has_content: true,
      has_subject: true,
      send_to_unsubscribed: null,
      campaign_id: '1',
    },
    {
      id: '69',
      type: 'multi_split_branch_action',
      action_state: 'running',
      name: 'What was their sign-up intent?',
      multi_conditions: [
        queryEncode([{ field: 'sign_up_path', operator: 'eq', type: 'attribute', value: 'created account' }]),
        queryEncode([{ field: 'sign_up_path', operator: 'eq', type: 'attribute', value: 'scheduled demo' }]),
      ],
      campaign_id: '1',
    },
    {
      id: '70',
      type: 'email_action',
      action_state: 'running',
      subject: 'Ready to learn more? ',
      name: 'Welcome to Rescue Time! ',
      sending_state: 'automatic',
      tracked: true,
      use_message_limits: null,
      has_content: true,
      has_subject: true,
      send_to_unsubscribed: null,
      campaign_id: '1',
    },
    {
      id: '71',
      type: 'delay_seconds_action',
      action_state: 'running',
      delay: 259200,
      campaign_id: '1',
    },
    {
      id: '72',
      type: 'email_action',
      action_state: 'running',
      subject: 'Promoting work/life balance',
      name: 'Educate',
      sending_state: 'automatic',
      tracked: true,
      use_message_limits: null,
      has_content: true,
      has_subject: true,
      send_to_unsubscribed: null,
      campaign_id: '1',
    },
    {
      id: '73',
      type: 'email_action',
      action_state: 'running',
      subject: 'See why teams use RescueTime',
      name: 'Build Social Credibility',
      sending_state: 'automatic',
      tracked: true,
      use_message_limits: null,
      has_content: true,
      has_subject: true,
      send_to_unsubscribed: null,
      campaign_id: '1',
    },
    {
      id: '74',
      type: 'email_action',
      action_state: 'running',
      subject: 'Are your employees happy?',
      name: 'Problem/Solution Pitch',
      sending_state: 'automatic',
      tracked: true,
      use_message_limits: null,
      has_content: true,
      has_subject: true,
      send_to_unsubscribed: null,
      campaign_id: '1',
    },
    {
      id: '75',
      type: 'delay_seconds_action',
      action_state: 'running',
      delay: 86400,
      campaign_id: '1',
    },
    {
      id: '76',
      type: 'email_action',
      action_state: 'running',
      subject: 'Are you still interested?',
      name: 'Customer Success Check-in',
      sending_state: 'automatic',
      tracked: true,
      use_message_limits: null,
      has_content: true,
      has_subject: true,
      send_to_unsubscribed: null,
      campaign_id: '1',
    },
    {
      id: '77',
      type: 'email_action',
      action_state: 'running',
      subject: 'Not the right time?',
      name: 'Last Chance',
      sending_state: 'automatic',
      tracked: true,
      use_message_limits: null,
      has_content: true,
      has_subject: true,
      send_to_unsubscribed: null,
      campaign_id: '1',
    },
    {
      id: '78',
      type: 'delay_seconds_action',
      action_state: 'running',
      delay: 432000,
      campaign_id: '1',
    },
    {
      id: '79',
      type: 'delay_seconds_action',
      action_state: 'running',
      delay: 172800,
      campaign_id: '1',
    },
    {
      id: '80',
      type: 'delay_seconds_action',
      action_state: 'running',
      delay: 259200,
      campaign_id: '1',
    },
    {
      id: '86',
      type: 'delay_time_window_action',
      action_state: 'running',
      start_time: '16:00',
      end_time: '17:00',
      days: 'Tue',
      zone: 'customer_time_zone',
      fallback_zone: 'US/Central',
      has_content: false,
      has_subject: false,
      campaign_id: '1',
    },
    {
      id: '88',
      type: 'delay_time_window_action',
      action_state: 'running',
      start_time: '16:00',
      end_time: '17:00',
      days: 'Tue',
      zone: 'customer_time_zone',
      fallback_zone: 'US/Central',
      has_content: false,
      has_subject: false,
      campaign_id: '1',
    },
    {
      id: '90',
      type: 'delay_time_window_action',
      action_state: 'running',
      start_time: '16:00',
      end_time: '17:00',
      days: 'Tue',
      zone: 'customer_time_zone',
      fallback_zone: 'US/Central',
      campaign_id: '1',
    },
    {
      id: '91',
      type: 'delay_time_window_action',
      action_state: 'running',
      start_time: '16:00',
      end_time: '17:00',
      days: 'Tue',
      zone: 'customer_time_zone',
      fallback_zone: 'US/Central',
      campaign_id: '1',
    },
    {
      id: '92',
      type: 'delay_time_window_action',
      action_state: 'running',
      start_time: '16:00',
      end_time: '17:00',
      days: 'Tue',
      zone: 'customer_time_zone',
      fallback_zone: 'US/Central',
      has_content: false,
      has_subject: false,
      campaign_id: '1',
    },
    {
      id: '93',
      type: 'delay_time_window_action',
      action_state: 'running',
      start_time: '16:00',
      end_time: '17:00',
      days: 'Tue',
      zone: 'customer_time_zone',
      fallback_zone: 'US/Central',
      campaign_id: '1',
    },
    {
      id: '94',
      type: 'delay_time_window_action',
      action_state: 'running',
      start_time: '16:00',
      end_time: '17:00',
      days: 'Tue',
      zone: 'customer_time_zone',
      fallback_zone: 'US/Central',
      campaign_id: '1',
    },
  ],
  campaign_notes: [
    {
      id: '1',
      content: '🎬 Trigger: New RescueTime leads can either create an account or schedule a demo.',
      color: '#FFEB99',
      x: 589,
      y: -117,
      created_at: 1659724015,
      created_by: {
        first_name: 'Demo',
        last_name: '',
        email: 'demo@customer.io',
        id: 'demo',
      },
      updated_at: 1665701607,
      updated_by: {
        first_name: 'Demo',
        last_name: '',
        email: 'demo@customer.io',
        id: 'demo',
      },
      campaign: '1',
    },
    {
      id: '2',
      content:
        "🎖 Goal: Nurture leads towards upgrading to a paid plan — whether that's our Premium plan or our more enterprise, Teams plan",
      color: '#FFEB99',
      x: 361,
      y: -118,
      created_at: 1659724243,
      created_by: {
        first_name: 'Demo',
        last_name: '',
        email: 'demo@customer.io',
        id: 'demo',
      },
      updated_at: 1665701615,
      updated_by: {
        first_name: 'Demo',
        last_name: '',
        email: 'demo@customer.io',
        id: 'demo',
      },
      campaign: '1',
    },
    {
      id: '3',
      content:
        '🍓Strategy: We leverage the "fear of missing out" here, letting them know that we won\'t send any more messages. This play helps drive responses.',
      color: '#80FCDF',
      x: 800,
      y: 2283,
      created_at: 1659725653,
      created_by: {
        first_name: 'Demo',
        last_name: '',
        email: 'demo@customer.io',
        id: 'demo',
      },
      updated_at: 1665701530,
      updated_by: {
        first_name: 'Demo',
        last_name: '',
        email: 'demo@customer.io',
        id: 'demo',
      },
      campaign: '1',
    },
    {
      id: '4',
      content:
        '🍓Strategy: We learned from a win-back campaign that 2-3 days between touches drives the best engagement.',
      color: '#80FCDF',
      x: 779,
      y: 887,
      created_at: 1659732080,
      created_by: {
        first_name: 'Demo',
        last_name: '',
        email: 'demo@customer.io',
        id: 'demo',
      },
      updated_at: 1665701581,
      updated_by: {
        first_name: 'Demo',
        last_name: '',
        email: 'demo@customer.io',
        id: 'demo',
      },
      campaign: '1',
    },
    {
      id: '5',
      content:
        '🍓Strategy: People get a ton of emails which means our messages might just be lost. This 1 day delay helps bring the message back up.',
      color: '#80FCDF',
      x: 801,
      y: 1642,
      created_at: 1659732216,
      created_by: {
        first_name: 'Demo',
        last_name: '',
        email: 'demo@customer.io',
        id: 'demo',
      },
      updated_at: 1665701560,
      updated_by: {
        first_name: 'Demo',
        last_name: '',
        email: 'demo@customer.io',
        id: 'demo',
      },
      campaign: '1',
    },
    {
      id: '6',
      content:
        '💡Tool Tip: RescueTime has customers all over the world, so the Time Window feature allows us to send messages in their time zone.',
      color: '#E1C9FF',
      x: -161,
      y: 626,
      created_at: 1659732534,
      created_by: {
        first_name: 'Demo',
        last_name: '',
        email: 'demo@customer.io',
        id: 'demo',
      },
      updated_at: 1665701588,
      updated_by: {
        first_name: 'Demo',
        last_name: '',
        email: 'demo@customer.io',
        id: 'demo',
      },
      campaign: '1',
    },
    {
      id: '7',
      content:
        '💡Tool Tip: We want to engage trial account and demo request leads differently, so we split them into different messaging paths.',
      color: '#E1C9FF',
      x: 746,
      y: 95,
      created_at: 1659733137,
      created_by: {
        first_name: 'Demo',
        last_name: '',
        email: 'demo@customer.io',
        id: 'demo',
      },
      updated_at: 1665701595,
      updated_by: {
        first_name: 'Demo',
        last_name: '',
        email: 'demo@customer.io',
        id: 'demo',
      },
      campaign: '1',
    },
    {
      id: '8',
      content:
        '💡Tool Tip: We use the custom conversion goals feature to move leads out of this campaign as soon as they upgrade.',
      color: '#E1C9FF',
      x: 141,
      y: 2285,
      created_at: 1659733635,
      created_by: {
        first_name: 'Demo',
        last_name: '',
        email: 'demo@customer.io',
        id: 'demo',
      },
      updated_at: 1665701516,
      updated_by: {
        first_name: 'Demo',
        last_name: '',
        email: 'demo@customer.io',
        id: 'demo',
      },
      campaign: '1',
    },
    {
      id: '9',
      content:
        '🍓Strategy: Just as a customer success team might send a manual check-in with a lead, we automate this, but with the same helpful tone.',
      color: '#80FCDF',
      x: -165,
      y: 1145,
      created_at: 1659733793,
      created_by: {
        first_name: 'Demo',
        last_name: '',
        email: 'demo@customer.io',
        id: 'demo',
      },
      updated_at: 1665701573,
      updated_by: {
        first_name: 'Demo',
        last_name: '',
        email: 'demo@customer.io',
        id: 'demo',
      },
      campaign: '1',
    },
    {
      id: '10',
      content:
        "🎖Next: If leads don't convert to a paid plan, they exit this campaign and we move them into another segment for future re-engagement.",
      color: '#FFEB99',
      x: 483,
      y: 2546,
      created_at: 1659733911,
      created_by: {
        first_name: 'Demo',
        last_name: '',
        email: 'demo@customer.io',
        id: 'demo',
      },
      updated_at: 1665701520,
      updated_by: {
        first_name: 'Demo',
        last_name: '',
        email: 'demo@customer.io',
        id: 'demo',
      },
      campaign: '1',
    },
  ],
});
